// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, object, string } from 'prop-types'
import AdditionalTrigger from './AdditionalTrigger'

const Cell = props => {
  const {
    additional,
    columnKey,
    label,
    idr,
    primary: {
      antennaCode,
      modelNumber,
    },
    TooltipTrigger,
  } = props

  return (
    <div className={'path-summary-site-cell'}>
      <span
        className={'text-ellipsis margin-right-auto'}
        data-label={label}
        id={`${idr}primary`}
        title={`Antenna Code: ${antennaCode}`}>
        {modelNumber}
      </span>
      <AdditionalTrigger
        columnKey={columnKey}
        additional={additional}
        idRoot={`${idr}tooltip`}
        TooltipTrigger={TooltipTrigger} />
    </div>
  )
}

Cell.propTypes = {
  additional: array.isRequired,
  columnKey: string.isRequired,
  idr: string.isRequired,
  label : string.isRequired,
  primary: object.isRequired,
  TooltipTrigger: func.isRequired,
}

export default Cell
